import React, { Component } from 'react';

class DynamicSelect extends Component {
  constructor(props) {
    super(props);
  }

  handleChange = event => {
    let selectedValue = event.target.value;
    this.props.onSelectChange(selectedValue);
  };

  render() {
    const { handleChange, selectedValue, arrayOfData, ...props } = this.props;
    const options = arrayOfData.map(data => (
      <option key={data.id} value={data.id}>
        {data.name}
      </option>
    ));

    return (
      <select
        name="customSearch"
        className="custom-search-select"
        onChange={handleChange}
      >
        <option>Selecione</option>
        {options}
      </select>
    );
  }
}

export default DynamicSelect;
